import { useContext, useEffect, useRef } from 'react';
import { useFetchAnalysisStructureQuery, useSaveReportMutation } from '../service';
import { AnalysisInProgressContext } from '../ContextWrapper';
import { getFlatSections } from '../utils';
import { getCompetitorsGeneralScoreData, getGeneralScoreData } from '../report/utils';

export default function useLiveAnalysisWithSaving() {
    const {
        isAnalysisInProgress,
        lastAnalysisGuid,
        lastAnalysisCreatedAt,
        lastAnalysisUrl,
        lastAnalysisSections,
        lastAnalysisCompetitors,
        sectionResults,
        competitorSectionResults,
    } = useContext(AnalysisInProgressContext);

    const { data: analysisStructure } = useFetchAnalysisStructureQuery({ fields: ['key', 'title', 'relevance'] });

    const lastAnalysisProgressRef = useRef<boolean>(isAnalysisInProgress);

    const [saveReport] = useSaveReportMutation();

    useEffect(() => {
        if (!analysisStructure) {
            return;
        }

        const handleSaveReport = async () => {
            const allSections = getFlatSections(analysisStructure);
            const hasAllSections = allSections.length === lastAnalysisSections.length;

            const selectedSections = allSections.filter((section) => lastAnalysisSections.includes(section.key));
            const mainUrlScoreData = getGeneralScoreData(selectedSections, sectionResults);

            const competitorUrls = lastAnalysisCompetitors.map((competitor) => competitor.websiteUrl);
            const competitorsScoreData = getCompetitorsGeneralScoreData(competitorUrls, selectedSections, competitorSectionResults);

            const mainUrlOverview = {
                has_all_sections: hasAllSections,
                ...mainUrlScoreData,
            };
            const competitorOverviews = lastAnalysisCompetitors.map((competitor) => ({
                guid: competitor.reportGuid,
                url: competitor.websiteUrl,
                overview: {
                    has_all_sections: hasAllSections,
                    ...competitorsScoreData[competitor.websiteUrl],
                },
            }));

            try {
                await saveReport({ url: lastAnalysisUrl!, guid: lastAnalysisGuid!, overview: mainUrlOverview, competitors: competitorOverviews }).unwrap();
            } catch (error) {}
        };

        if (lastAnalysisProgressRef.current === true && isAnalysisInProgress === false) {
            lastAnalysisProgressRef.current = false;
            handleSaveReport();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAnalysisInProgress]);

    return {
        analysisStructure,
        isAnalysisInProgress,
        lastAnalysisGuid,
        lastAnalysisCreatedAt,
        lastAnalysisUrl,
        lastAnalysisSections,
        lastAnalysisCompetitors,
        sectionResults,
        competitorSectionResults,
    };
}
